import React, { Component } from 'react';
import { Dialog } from '@blueprintjs/core';
import Media from 'react-media';
import findIndex from 'lodash.findindex';
import SortableCardList from './SortableCardList';
import SortableCardListMobile from './SortableCardListMobile';
import './ProfilePage.css';

class ProfilePage extends Component {
  state = {
    isOpen: false,
    dialogOpenFor: null,
    volunteerList: [],
    coachList: [],
    selectedTeamId: ''
  };

  componentDidMount() {
    const {
      memberId,
      teamsVolunteering,
      getCoachesTeams,
      getTeamsVolunteering,
      getSeasonDivisions,
      getTeams,
      teamsCoaching,
      userSeason
    } = this.props;

    getSeasonDivisions(userSeason);
    getTeams(0,0);
    getTeamsVolunteering(memberId, userSeason);
    getCoachesTeams(memberId, userSeason);

    this.setState({ volunteerList: teamsVolunteering, coachList: teamsCoaching });
  }

  componentDidUpdate(prevProps) {
    const { getTeamsVolunteering, getCoachesTeams, getSeasonDivisions, getTeams,
      userSeason, memberId, teamsVolunteering, teamsCoaching } = this.props;
    if(this.props !== prevProps){
      if(userSeason !== prevProps.userSeason){
        getSeasonDivisions(userSeason);
        getTeams(0,0);
        getTeamsVolunteering(memberId, userSeason);
        getCoachesTeams(memberId, userSeason);
      }
      this.setState({ volunteerList: teamsVolunteering, coachList: teamsCoaching });
    }
  }
  teamsCoachingLoaded = () => {
    const { teamsCoachingStatus } = this.props;
    return teamsCoachingStatus === 'Loaded' || teamsCoachingStatus === 'Error';
  }

  teamsVolunteeringLoaded = () => {
    const { teamsVolunteeringStatus } = this.props;
    return teamsVolunteeringStatus === 'Loaded' || teamsVolunteeringStatus === 'Error' || teamsVolunteeringStatus === 'Updated';
  }

  handleNewList = newList => {
    this.setState({ ...this.state, volunteerList: newList });
    const { memberId, updateTeamVolunteer } = this.props;
    updateTeamVolunteer(memberId, null, null, 'teamPriority', newList, 'update');
  };

  toggleDialog = (event, sectionThatOpenedDialog) => {
    const { getTeams } = this.props;
    event.preventDefault();
    this.setState({ isOpen: !this.state.isOpen, dialogOpenFor: sectionThatOpenedDialog });
    //Reset Team List
    getTeams(0,0);
  };

  handleDivisionSelect = event => {
    const { value } = event.target;
    this.props.getTeams(value, this.props.userSeason);
    this.setState({ ...this.state, selectedDivision: value });
  };

  handleTeamSelect = event => {
    const { value } = event.target;
    this.setState({ ...this.state, selectedTeamId: value, selectedTeam: this.props.teams[value].name });
  };

  handleGamesCommitted = (teamId, value) => {
    const { memberId, teamsVolunteering, updateTeamVolunteer } = this.props;
    const index = findIndex(teamsVolunteering, teamObj => teamObj.teamId === teamId);
    const { seasonId } = teamsVolunteering[index];
    updateTeamVolunteer(memberId, seasonId, teamId, 'gamesCommitted', value, 'update');
  };

  handleTeamPriority = (teamId, value) => {
    const { memberId, teamsVolunteering, updateTeamVolunteer } = this.props;
    const index = findIndex(teamsVolunteering, teamObj => teamObj.teamId === teamId);
    const { seasonId } = teamsVolunteering[index];
    updateTeamVolunteer(memberId, seasonId, teamId, 'teamPriority', value, 'update');
  };

  handleAddTeam = () => {
    const { dialogOpenFor } = this.state;
    const {
      memberId,
      teams,
      teamsVolunteering,
      updateTeamVolunteer,
    } = this.props;
    const initialTeamPriority = teamsVolunteering.length + 1;

    if (this.teamSelect.value === '') return;

    if (dialogOpenFor === 'volunteer') {
      this.setState({
        ...this.state,
        volunteerList: [
          ...this.state.volunteerList,
          {
            teamId: this.teamSelect.value,
            seasonId: this.props.userSeason,
            teamName: teams[this.teamSelect.value].name,
            gamesCommitted: 1,
            teamPriority: initialTeamPriority
          }
        ]
      });
      updateTeamVolunteer(memberId, this.props.userSeason, this.teamSelect.value, 'teamId', initialTeamPriority, 'insert');
    }
    this.setState({ isOpen: false });
    this.setState({ selectedTeamId: '' });
  };

  handleRemoveTeam = (team, index) => {
    const { memberId, updateTeamVolunteer } = this.props;
    const { volunteerList } = this.state;
    const newList = [...volunteerList.slice(0, index), ...volunteerList.slice(index + 1)];
    this.setState({ volunteerList: newList });
    updateTeamVolunteer(memberId, team.seasonId, team.teamId, 'teamId', newList, 'delete');
  };

  render() {
    const {
      seasonDivisions, seasonDivisionsList, fetchingSeasonDivisionsStatus,
      name, email, phone, teams, teamsCoaching, teamsList
    } = this.props;
    const { volunteerList, coachList } = this.state;

    if (fetchingSeasonDivisionsStatus === 'Loaded') {
      return (
        <div className="user-profile-container">
          <div className="profile-container">
            <div className="card">
              <div className="header">
                <h1>Profile</h1>
              </div>
              <div className="contact-info-container">
                <h3>{name}</h3>
                <div className="phone-email-container">
                  <h4>
                    <span className="pt-icon-standard pt-icon-phone" />
                    {phone}
                  </h4>
                  <h4>
                    <span className="pt-icon-standard pt-icon-envelope" />
                    {email}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="profile-container">
            <div className="card">
              <div className="header">
                <h1>Teams Represented</h1>
                <div className="btn-container">
                  <button
                    className="pt-button pt-minimal pt-icon-plus"
                    onClick={e => this.toggleDialog(e, 'volunteer')}
                  />
                </div>
              </div>
              <div className="volunteer-container">
                {volunteerList.length === 0 ? (
                  <h4>You are not assigned as a volunteer</h4>
                ) : (
                  <Media query="(hover: none)">
                    {matches =>
                      matches ? (
                        <SortableCardListMobile
                          list={volunteerList}
                          handleNewList={this.handleNewList}
                          handleGamesCommitted={this.handleGamesCommitted}
                          handleRemoveTeam={this.handleRemoveTeam}
                        />
                      ) : (
                        <SortableCardList
                          list={volunteerList}
                          handleNewList={this.handleNewList}
                          handleGamesCommitted={this.handleGamesCommitted}
                          handleRemoveTeam={this.handleRemoveTeam}
                        />
                      )
                    }
                  </Media>
                )}
              </div>
            </div>
          </div>
          <div className="profile-container">
            <div className="card">
              <div className="header">
                <h1>Teams Coaching</h1>
              </div>
              <div className="coaching-container">
                {teamsCoaching.length === 0 ? (
                  <h4 className="no-coach-teams">You are not assigned as a coach</h4>
                ) : (
                  coachList.map((team, teamsCoachingIndex) => {
                    return (
                      <div className="coach-team" key={team.teamId}>
                        <div className="coach-team-details">
                          <h4>{team.teamName}</h4>
                          <h5>{team.divisionName}</h5>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
          <Dialog className="profile-dialog" isOpen={this.state.isOpen} onClose={this.toggleDialog} title="Select Team">
            <div className="pt-dialog-body">
              <label className="pt-label">
                Select Division:
                <select
                  name="divisions"
                  id="divisions"
                  className="pt-select"
                  onChange={this.handleDivisionSelect}
                  ref={select => (this.divisionSelect = select)}
                >
                  <option id='none' key='none' value=''>
                    Choose Division
                  </option>
                  {seasonDivisionsList.map(divisionId => {
                      return (
                        <option id={divisionId} key={divisionId} value={divisionId}>
                          {seasonDivisions[divisionId].name}
                        </option>
                      );
                    })
                  }
                </select>
              </label>
              <label className="pt-label">
                Select Team:
                <select
                  name="teams"
                  id="teams"
                  className="pt-select"
                  onChange={this.handleTeamSelect}
                  ref={select => (this.teamSelect = select)}
                >
                <option id='none' key='none' value=''>
                  Choose Team
                </option>
                  {teamsList.map(teamId => {
                    return (
                      <option id={teamId} key={teamId} value={teamId}>
                        {teams[teamId].name}
                      </option>
                    );
                  })}
                </select>
              </label>
              <div className="dialog-btn-container">
                <button
                  className="pt-button pt-intent-primary"
                  onClick={this.handleAddTeam}
                  disabled={!this.state.selectedTeamId}
                >
                  Add Team
                </button>
              </div>
            </div>
          </Dialog>
        </div>
      );
    }

    return (
      <div className="user-profile-container">
        <div className="profile-container">
        </div>
      </div>
    );
  }
}

export default ProfilePage;



// WEBPACK FOOTER //
// ./src/components/ProfilePageV2.js